import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import AppFrame from './components/AppFrame';
import DashboardPage from './pages/DashboardPage';
import ConversationsPage from './pages/ConversationsPage';
import SettingsPage from './pages/SettingsPage';
import { StoreProvider, useStore } from './lib/useStore';

/** Analytics is PRO — FREE stores land on Conversations instead. */
function HomeRoute(): ReactNode {
  const { store, loading } = useStore();
  if (!loading && store?.plan === 'FREE') return <Navigate to="/conversations" replace />;
  return <DashboardPage />;
}

export default function App(): ReactNode {
  return (
    <StoreProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<AppFrame />}>
            <Route path="/" element={<HomeRoute />} />
            {/* List + detail share the three-pane layout. */}
            <Route path="/conversations" element={<ConversationsPage />} />
            <Route path="/conversations/:id" element={<ConversationsPage />} />
            <Route path="/settings" element={<SettingsPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </StoreProvider>
  );
}
